<div class="flex items-center justify-between w-full max-w-xl">
  <button type="button" class="flex items-center gap-1 bg-transparent border-none p-0 cursor-pointer" (click)="backClicked.emit()">
    <mat-icon svgIcon="ph-regular-caret-left" class="text-title"></mat-icon>
    <span class="text-title font-medium">{{ label | translate }}</span>
  </button>
  <div *ngIf="showLogo" class="flex items-center justify-center h-12 px-2 py-1">
    <img class="h-full w-full max-w-24 object-contain" src="assets/img/toolbar_logo.png" alt="">
  </div>
</div>
